<template>
  <v-main>
    <ConfList />
    <Conferences />
    <ConfMembers />
  </v-main>
</template>

<script>
import Conferences from '@/components/conferences'
import ConfList from '@/components/conferences/list'
import ConfMembers from '@/components/conferences/members'
export default {
  name: 'view-conferences',
  components: { ConfList, Conferences, ConfMembers }
}
</script>

<style scoped>
</style>
